<template>
    <div>
        <div style="display: flex; flex-direction: column">
            <div style="width: 50%;">
                <VueDateFilter @dateFilterChange="dateFilterApplied" />
            </div>
        </div>
        <div class="form-group" style="margin-top: 16px; width: 50%;">
            <label for="ow">Select Traffic code</label>

            <Select2
                v-model="selectedOptions"
                :options="trafficCodeSelectOptions"
                :settings="{multiple: true}"
                @change="selectTrafficCode"
            />
        </div>
        <div class="btn-group crud-form-action-btn">
            <button :disabled="isLoading" @click="handleGenerateReport" type="submit" class="btn btn-success">Generate report</button>
        </div>

        <div v-if="isLoading" class="loader" id="loader-1"></div>
    </div>
</template>

<script>

import VueDateFilter from "../../generic/VueDateFilter";
import Pagination from "../../common/Pagination";
import Select2 from 'v-select2-component';

const PER_PAGE = 10;

export default {
    name: "TrafficCodeLogReport",
    components: {
        Pagination,
        VueDateFilter,
        Select2
    },
    props: [
        'trafficCodeSelectOptions'
    ],
    data() {
        return {
            isLoading: false,
            dateFrom: null,
            dateTo: null,
            codeLogTraffic: {},
            pageCount: 0,
            pageNumber: 0,
            filters: {
                start: null,
                end: null,
            },
            selectedOptions: [],
        }
    },
    computed: {
        paginatedItems() {
            const start = this.pageNumber * PER_PAGE,
                end = start + PER_PAGE;

            return Object.keys(this.codeLogTraffic).slice(start, end).reduce((result, key) => {
                result[key] = this.codeLogTraffic[key];
                return result;
            }, {});
        },
    },
    methods: {
        generateReport() {
            this.isLoading = true;
            axios.post('/traffic-code-log-report-requests', this.filters).then((response) => {
                this.isLoading = false;
                console.log(response);
                alert(response.data.message);
                window.location.href = response.data.redirect;

            }).catch(({response, request}) => {
                if(response.data && response.data.errors) {
                    for (const property in response.data.errors) {
                    }
                }
                this.isLoading = false;
            })
        },
        dateFilterApplied(dateFromTimestamp, dateToTimestamp, type) {
            this.filters.start = dateFromTimestamp;
            this.filters.end = dateToTimestamp;
        },
        changePage(fromPage, toPage) {
            this.pageNumber = toPage;
        },
        selectTrafficCode(event) {
            this.filters.traffic_code_ids = event;
        },
        handleGenerateReport() {
            this.generateReport();
        }
    }
}
</script>

<style scoped lang="scss">
    @import "../../../../../sass/admin-panel/partials/_loader.scss";
</style>



// WEBPACK FOOTER //
// resources/js/admin-panel/components/admin/traffic-code-log-report/TrafficCodeLogReport.vue